// src/encounter/video-join-notice.tsx
//
// The Signal DS `VirtualVisitNotice` plus the reason Connect is not offered ("Video opens at 2:50 PM"). The DS notice
// has no disabled state: without `onConnect` it draws no action at all, so the reason sits beside it on the same line.
// Used by both surfaces that show the notice (the pre-encounter rail and the started encounter), so they cannot drift.

import { VirtualVisitNotice } from '@scripsteam/scrips-signal-ds';

export interface VideoJoinNoticeProps {
  inCall: boolean;
  /** Absent outside the join window: the notice then shows no Connect. */
  onConnect?: () => void;
  onLeave?: () => void;
  /** Why Connect is not offered (lib/video-join-window.ts `videoJoinReason`). Ignored while in a call. */
  reason?: string;
}

export function VideoJoinNotice({ inCall, onConnect, onLeave, reason }: VideoJoinNoticeProps) {
  const notice = <VirtualVisitNotice inCall={inCall} onConnect={onConnect} onLeave={onLeave} />;
  if (inCall || !reason) return notice;
  return (
    <div data-slot="video-join">
      {notice}
      <p data-slot="video-join-reason" className="m-0">
        {reason}
      </p>
    </div>
  );
}
